import React, { useState, useEffect } from 'react';
import Menu from './Menu';
import Register from './Register';
import Login from './Login';
import AddPlant from './AddPlant';
import UserLogged from './UserLogged';
import About from './About';
import Contact from './Contact';
import priceData from './data/may_pse_price.json';
import './App.css';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

function HomePage() {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    if (priceData && priceData.value) {
      const formattedData = priceData.value.map(item => ({
        time: item.period,
        price: item.rce_pln
      }));
      setChartData(formattedData);
    }
  }, []);

  return (
    <div className="home-page">
      <div className="home-content">
        <h1>Res-whisper Energy Management App</h1>
        <p>Aplikacja która, pozwoli Ci zmaksymalizować zysk z instalacji fotowoltaicznej z magazynem energii.
        Poniższy wykres przedstawia jak wygladaly ceny zakupu enregii od prosumentow i podmiotow wytwarzajacych energie,
         na rynku hurtowym na w maju. Takie ceny nie sa rzadkością.
        Obecnie coraz częściej mamy do czynienia z tego typu anomaliami na rynku energii. Jeżeli jesteś właścicielem fotowoltaiki
        i masz magazyn energii, możesz zmaksymalizować swoje zyski. Wystarczy, ze bedziesz ładował magazyn, gdy ceny sa
        ujemne lub bardzo niskie, zazwyczaj w okolicach godziny 12:00 gdy instalacje fotowoltaiczne w Polsce generuja najwiecej
         energii. Nasza aplikacja oparta na modelach machine learninng pozwoli Ci automatycznie sprzedac energie w najkorzystniejszych godzinach.
         Aplikacj bierze pod uwage lokalne warunki pogodowe i wyznacza kiedy rozladowac, a kiedy naladowac baterie.

         Priorytetem jest aut konsumpcja, dlatego w deszczowy dzien warto jest miec naladowany magazyn.</p>

        <div className="chart-container">
          <h2>Ceny energii - Maj 2026</h2>
          <ResponsiveContainer width="100%" height={400}>
            <BarChart data={chartData} margin={{ top: 5, right: 20, left: 20, bottom: 60 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="rgba(46, 125, 50, 0.2)" />
              <XAxis
                dataKey="time"
                angle={-45}
                textAnchor="end"
                height={100}
                interval={Math.floor(chartData.length / 10) || 0}
                tick={{ fill: '#2E7D32', fontSize: 11 }}
              />
              <YAxis
                label={{ value: 'Cena (PLN)', angle: -90, position: 'insideLeft', fill: '#2E7D32' }}
                tick={{ fill: '#2E7D32' }}
              />
              <Tooltip
                contentStyle={{
                  backgroundColor: 'white',
                  border: '2px solid #2E7D32',
                  borderRadius: '4px'
                }}
                formatter={(value) => `${value.toFixed(2)} PLN`}
              />
              <Legend wrapperStyle={{ color: '#2E7D32' }} />
              <Bar
                dataKey="price"
                fill="#4CAF50"
                name="Cena energii"
                radius={[4, 4, 0, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="app-layout">
        <Menu />
        <main className="app-main">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/addplant" element={<AddPlant />} />
            <Route path="/userlogged" element={<UserLogged />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;